export const identity = {
    yourIdentity: {
        revealIdentity: 'Visseblåsares identitet',
        yesRevealIdentity: 'Ja, jag vill uppge min identitet.',
        noDontRevealIdentity: 'Nej, jag vill vara anonym.',
    }
};
